export const fastRandomId = (prefix?: string) => {
	return [prefix, Math.random().toString(36).slice(2, 10)].filter(Boolean).join('-');
};
